const en = {
  attach: 'Attach',
  add_to_email: 'Add to email',
  attach_as_pdf: 'Attach as PDF',
  attach_as_pdf_save_copy: 'Attach as PDF and save copy',
  cancel: 'Cancel',
  change_sort: 'Sort Order',
  clear: 'Clear',
  close: 'Close',
  contact_page_title: 'Contacts',
  contact_manager_menu_title: 'PDS CM',
  contact_person_title: 'Contact Persons',
  create_folder: 'Create folder',
  document_library: 'Document Library',
  email: 'Email',
  favorite: 'Favorite',
  explain_login: 'You don\'t have an account with PDS. Contact your PDS administrator or send en email to us to set it up for your organization.',
  filename: 'File Name',
  file_search_clear: 'Clear Search',
  file_search_tooltip_idle: 'Search',
  file_search_tooltip_searching: 'Searching',
  file_search_no_results: 'No Results.',
  fill_content_control: 'Fill in',
  intranet_page_title: 'Intranet',
  language: 'Language',
  loading: 'Loading...',
  login_error_retry_button: 'Reload page and try again',
  login_error_logout_button: 'Logout and try again',
  logout: 'Logout',
  mailto_subject: 'I\'d like to order / set up PDS for my organization!',
  navigate_first_page: 'First Page',
  navigate_back_many: '-10',
  navigate_back: '-1',
  navigate_forward: '+1',
  navigate_forward_many: '+10',
  navigate_last_page: 'Last Page',
  page_info: 'Page / Total pages',
  items_per_page: 'Items per page',
  no_options: 'No options',
  open: 'Open',
  save_pdf_copy: 'Save a PDF copy in the same folder',
  save_pdf_copy_disabled: 'Save a PDF copy (not available for this file type)',
  save_pdf_copy_unsupported_tooltip: 'Not available for this file type. Supported file types: %1',
  oops_title: 'Whooops !',
  paste_person_data: 'Paste',
  people_dialog_title: 'People with roles',
  project_page_title: 'Projects',
  page_title_with_pagination: '%1 (%2/%3)',
  reply: 'Reply',
  reply_all: 'Reply All',
  rename: 'Rename',
  rename_name_exists: 'An item with that name already exists in this folder.',
  rename_invalid_chars_removed: 'Illegal characters were removed from the name.',
  rename_invalid_chars: 'Name contains characters that are not allowed in SharePoint.',
  create_folder_invalid_chars: 'Folder name contains characters that are not allowed in SharePoint.',
  rename_extension_warning: 'Changing file extension can affect how the file opens.',
  delete: 'Delete',
  move_to_trash: 'Move to trash',
  remove_permanently: 'Remove permanently',
  delete_item_confirm: 'Delete "%1"?',
  delete_confirm_checkbox: 'I understand this cannot be undone',
  delete_file_confirm: 'Delete file "%1"?',
  delete_item_type_file: 'File',
  delete_item_type_folder: 'Folder',
  delete_folder_has_content_with_count: 'This folder contains %1 item(s). Deleting it will remove all included files and folders.',
  DELETE_LOCK_HINT_FOLDER_LOCKED_BY_USER: 'Cannot delete this folder because "%2" is currently open by %1. Ask that user to close the file and try again.',
  DELETE_LOCK_HINT_FOLDER_FILE_IN_USE: 'Cannot delete this folder because "%1" is currently in use. Close the file and try again.',
  DELETE_HINT_FOLDER_NOT_EMPTY: 'Cannot delete this folder right now. Try again in a moment.',
  DELETE_HINT_FOLDER_NOT_EMPTY_WITH_COUNT: 'Cannot delete this folder right now. Try again in a moment.',
  advanced_upload: 'Advanced Save Attachments',
  advanced_upload_partial_match: 'Matched %1 of %2 dragged attachments. You can still select from the list below.',
  rename_attachments: 'Rename Attachments',
  rename_attachments_dialog_title: 'Rename Attachments',
  save_attachments_to_folder: 'Save attachments to folder',
  attachment_name: 'Attachment Name',
  attachment_name_with_index: '%1 %2',
  attachment_name_duplicate: 'Attachment names must be unique.',
  attachment_name_exists_in_target: 'File exists. Rename it or save as a new version.',
  overwrite_file_confirm: 'The file "%1" already exists. Click Overwrite to replace it or Abort to cancel.',
  overwrite_dialog_title: 'Overwrite file?',
  overwrite_action: 'Overwrite',
  abort_action: 'Abort',
  uploaded_to_folder: 'Uploaded to: %1',
  DROP_SAVE_SUCCESS: 'Saved successfully.',
  SEND_AND_FILE_SUCCESS: 'Sent and saved successfully.',
  SEND_AND_FILE_WAIT_MESSAGE: 'Send and file is working. Do not close the compose window.',
  select_all_none: 'Select all/none',
  save: 'Save',
  save_to_folder: 'Save to folder',
  save_to_folder_tooltip: 'Upload selected attachments to the target folder using the file names shown in this list. The dialog remains open so you can continue saving to other folders.',
  save_as: 'Save As',
  save_dialog_title: 'Save',
  save_attachments: 'Save Attachments',
  application: 'Application',
  send_and_file_diagnostics: 'Send and file diagnostics',
  send_and_file_diagnostics_description: 'Copy the last 100 send-and-file diagnostic events. The report does not contain email content, attachment names, recipients, tokens, or message IDs.',
  copy_send_and_file_diagnostics: 'Copy diagnostics',
  clear_send_and_file_diagnostics: 'Clear diagnostics',
  send_and_file_diagnostics_copied: 'Diagnostics copied to the clipboard.',
  send_and_file_diagnostics_empty: 'No send-and-file diagnostics have been recorded.',
  send_and_file_diagnostics_copy_failed: 'Could not copy diagnostics. Try again in a supported Office client.',
  send_and_file_export_manual_copy: 'Clipboard access is unavailable. Select all text below and copy it manually.',
  copy_send_and_file_timings: 'Copy timings',
  clear_send_and_file_timings: 'Clear timings',
  send_and_file_timings_copied: 'Timings copied to the clipboard.',
  send_and_file_timings_empty: 'No send-and-file timings have been recorded.',
  send_and_file: 'Send and File',
  session: 'Session',
  settings_dialog_title: 'Settings',
  show_favorites: 'Favorites',
  show_active: 'Active only',
  show_recent: 'Recent',
  templates_page_title: 'Templates',
  templates_root_node: 'Templates',
  target_folder: 'Target folder',
  tenant: 'Tenant',
  version: 'Version',
  user_name: 'Name',

  PROGRESS_TITLE_UPLOAD_FILE: 'Save',
  PROGRESS_STATUS_READ_FILE: 'Reading file data',
  PROGRESS_STATUS_WRITE_CUSTOM_XML: 'Writing custom xml',
  PROGRESS_STATUS_UPLOAD_FILE: 'Uploading to SharePoint',
  PROGRESS_STATUS_OPEN_FILE: 'Opening file on SharePoint. Please wait',

  PROGRESS_TITLE_SEND_AND_FILE: 'Send and File',
  PROGRESS_STATUS_SAVE_DRAFT_EMAIL: 'Saving draft',
  PROGRESS_STATUS_SET_CATEGORY_DRAFT_EMAIL: 'Setting category on draft',
  PROGRESS_STATUS_FETCH_EMAIL_WITH_RETRIES: 'Fetching draft email data from server. This can take some time. Please wait',
  PROGRESS_STATUS_SEND_DRAFT_EMAIL: 'Sending draft email',

  PROGRESS_TITLE_UPLOAD_ATTACHMENTS: 'Save Attachments',
  PROGRESS_STATUS_READ_ATTACHMENTS: 'Reading attachment file data from Outlook',
  PROGRESS_STATUS_UPLOAD_ATTACHMENTS: 'Uploading attachment %s to SharePoint',

  PROGRESS_TITLE_LOGOUT: 'Log out',
  PROGRESS_STATUS_LOGOUT: 'Logging out',

  PROGRESS_TITLE_ATTACH_FILE: 'Add Attachment',
  PROGRESS_STATUS_READ_SHAREPOINT_FILE: 'Reading file from SharePoint',
  PROGRESS_STATUS_ATTACH_FILE: 'Attaching file to email',

  // Error messages

  ERROR_TYPE_CATEGORY_GET: 'Failed to get intranet folders.',
  ERROR_TYPE_CATEGORY_NOT_FOUND: 'Could not find intranet folder.',
  ERROR_TYPE_CATEGORY_UPDATE: 'Failed to update intranet folder.',
  ERROR_TYPE_CATEGORY_NO_GET_PERMISSION: 'Not enough permissions to read intranet folder.',
  ERROR_TYPE_CATEGORY_NO_UPDATE_PERMISSION: 'Not enough permissions to update intranet folder.',

  ERROR_TYPE_CONTACT_GET: 'Failed to get contacts.',
  ERROR_TYPE_CONTACT_NOT_FOUND: 'Could not find contact.',
  ERROR_TYPE_CONTACT_UPDATE: 'Failed to update contact.',
  ERROR_TYPE_CONTACT_NO_GET_PERMISSION: 'Not enough permissions to read contact.',
  ERROR_TYPE_CONTACT_NO_UPDATE_PERMISSION: 'Not enough permissions to update contact.',

  ERROR_TYPE_CONTENT_TYPE_GET: 'Failed to get content types.',
  ERROR_TYPE_CONTENT_TYPE_NOT_FOUND: 'Could not find content type.',
  ERROR_TYPE_CONTENT_TYPE_NO_GET_PERMISSION: 'Not enough permissions to read content types.',

  ERROR_TYPE_DEPARTMENT_GET: 'Failed to get intranet sections.',
  ERROR_TYPE_DEPARTMENT_NOT_FOUND: 'Could not find intranet section.',
  ERROR_TYPE_DEPARTMENT_UPDATE: 'Failed to update intranet sections.',
  ERROR_TYPE_DEPARTMENT_NO_GET_PERMISSION: 'Not enough permissions to read intranet section.',
  ERROR_TYPE_DEPARTMENT_NO_UPDATE_PERMISSION: 'Not enough permissions to update intranet section.',

  ERROR_TYPE_DOC_LIB_GET: 'Failed to get files from document library.',

  ERROR_TYPE_EMAIL_READ: 'Failed to read email.',
  ERROR_TYPE_EMAIL_SAVE_DRAFT: 'Failed to save draft email.',
  ERROR_TYPE_EMAIL_SEND: 'Failed to send email.',

  ERROR_TYPE_FILE_ATTACH: 'Failed to attach file.',
  ERROR_TYPE_FILE_READ: 'Failed to read file data.',
  ERROR_TYPE_FILE_READ_ATTACHMENTS: 'Failed to read file attachments.',
  ERROR_TYPE_FILE_SAVED_ADD: 'Failed to add file saved event.',
  ERROR_TYPE_FILE_SAVED_NO_ADD_PERMISSION: 'Not enough permissions to add file saved event.',
  ERROR_TYPE_FILE_SAVE: 'Failed to save file.',
  ERROR_TYPE_FILE_LOCKED: 'The file is locked or currently in use. Close it and try again in a moment.',
  ERROR_TYPE_FILE_PDF_CONVERSION: 'The selected file could not be converted to PDF. Try another file or add printable content and try again.',
  ERROR_TYPE_FILE_SEARCH: 'Searching for files failed.',
  ERROR_TYPE_FILE_UPLOAD: 'Failed to upload file.',
  ERROR_TYPE_FILE_UPLOAD_ATTACHMENTS: 'Failed to upload file attachments.',
  ERROR_TYPE_FILE_RENAME: 'Failed to rename item.',
  ERROR_TYPE_FILE_RENAME_INVALID: 'Failed to rename item. Check that the name is valid and not already in use.',
  ERROR_TYPE_FILE_RENAME_LOCKED: 'Failed to rename item. The file is locked or currently in use. Try again in a moment.',
  FILE_LOCK_HINT_GENERIC: 'The file is locked or currently in use. Close it and try again in a moment.',
  FILE_LOCK_HINT_LOCKED_BY_USER: 'Locked by %1. Ask that user to close the document, then try again.',
  FILE_LOCK_HINT_CHECKED_OUT_BY_USER: 'Checked out by %1. Ask that user to check in or close the document, then try again.',
  RENAME_LOCK_HINT_GENERIC: 'The file or folder is in use. Close it in Word/Outlook and try again in a moment.',
  RENAME_LOCK_HINT_LOCKED_BY_USER: 'Locked by %1. Ask that user to close the document, then try again.',
  RENAME_LOCK_HINT_FOLDER_LOCKED_BY_USER: 'A file in this folder is locked by %1 (%2). Ask that user to close it, then try again.',
  RENAME_LOCK_HINT_FOLDER_FILE_IN_USE: 'A file in this folder is in use (%1). Close it and try again.',
  ERROR_TYPE_FILE_DELETE: 'Failed to delete file.',
  ERROR_TYPE_FOLDER_NOT_EMPTY: 'Could not delete folder.',
  ERROR_TYPE_FOLDER_CREATED_ADD: 'Failed to create folder.',
  ERROR_TYPE_PROJECT_GET: 'Failed to get projects.',
  ERROR_TYPE_PROJECT_NOT_FOUND: 'Could not find project.',
  ERROR_TYPE_PROJECT_UPDATE: 'Failed to update project.',
  ERROR_TYPE_PROJECT_NO_GET_PERMISSION: 'Not enough permissions to read project.',
  ERROR_TYPE_PROJECT_NO_UPDATE_PERMISSION: 'Not enough permissions to update project.',

  // Generic errors.

  ERROR_TYPE_AUTH: 'Authentication error. Try to login again.',
  ERROR_TYPE_LOGIN: 'Failed to login. Contact your administrator and make sure you have an account registered with PDS.',
  ERROR_TYPE_NETWORK: 'Connection refused. Make sure you have a working internet connection.',
  ERROR_TYPE_UNKNOWN: 'Unknown error. Please try again later.',
  error_with_details: '%1 (%2)',

  // Content type fields
  pdscol_archived_date: 'Archived Date',
  pdscol_contact_name: 'Contact',
  pdscol_document_class: 'Document Type',
  pdscol_document_date: 'Document Date',
  pdscol_document_information: 'Document Information',
  pdscol_document_status: 'Document Status',
  pdscol_entity: 'Area',
  pdscol_gdpr: 'GDPR',
  pdscol_object_type: 'Type',
  pdscol_responsible: 'Responsible',
  pdscol_system_owner: 'PDS System Owner',
  pdscol_tags: 'Tags',
  pdscol_contact_number: 'Contact Number',
  pdscol_project_name: 'Project',
  pdscol_project_number: 'Project Number',
  pdscol_project_responsible: 'Project Responsible',
  pdscol_department: 'Department',
  pdscol_reference_id1: 'Reference Id 1',
  pdscol_reference_id2: 'Reference Id 2',
  pdscol_time_reference: 'Time Reference',
  pdscol_email_receiver_address: 'Receiver of Email',
  pdscol_email_send_address: 'Sender of Email',
  pdscol_email_sent_time: 'Email Sent Time',
  pdscol_archived_time: 'Time in months until archived',
  pdscol_template_group: 'Template Group',
  pdscol_template_information: 'Template Information'
}

const sv = {
  attach: 'Bifoga',
  add_to_email: 'Lägg till i e-post',
  attach_as_pdf: 'Bifoga som PDF',
  attach_as_pdf_save_copy: 'Bifoga som PDF och spara kopia',
  cancel: 'Avbryt',
  change_sort: 'Sortering',
  clear: 'Rensa',
  close: 'Stäng',
  contact_page_title: 'Kontakter',
  contact_manager_menu_title: 'PDS CM',
  contact_person_title: 'Kontaktpersoner',
  create_folder: 'Skapa mapp',
  document_library: 'Dokumentbibliotek',
  email: 'Email',
  favorite: 'Favorit',
  explain_login: 'Du har inget konto registrerat hos PDS. Kontakta din administratör för PDS eller skicka ett mejl till oss för att sätta upp det i din organisation.',
  filename: 'Filnamn',
  file_search_clear: 'Återställ',
  file_search_tooltip_idle: 'Sök',
  file_search_tooltip_searching: 'Söker',
  file_search_no_results: 'Inga resultat.',
  fill_content_control: 'Fyll i',
  intranet_page_title: 'Intranät',
  language: 'Språk',
  loading: 'Laddar...',
  login_error_retry_button: 'Ladda om sidan och försök igen',
  login_error_logout_button: 'Logga ut och försök igen',
  logout: 'Logga ut',
  mailto_subject: 'Jag vill beställa/sätta upp PDS i min organisation!',
  navigate_first_page: 'Första sidan',
  navigate_back_many: '-10',
  navigate_back: '-1',
  navigate_forward: '+1',
  navigate_forward_many: '+10',
  navigate_last_page: 'Sista sidan',
  page_info: 'Sida / Totalt antal sidor',
  items_per_page: 'Antal objekt per sida',
  no_options: 'Inga resultat',
  open: 'Öppna',
  oops_title: 'Hoppsan !',
  paste_person_data: 'Klistra in',
  people_dialog_title: 'Personer med roller',
  project_page_title: 'Projekt',
  page_title_with_pagination: '%1 (%2/%3)',
  reply: 'Svara',
  reply_all: 'Svara alla',
  rename: 'Byt namn',
  rename_name_exists: 'Det finns redan en post med det namnet i den här mappen.',
  rename_invalid_chars_removed: 'Otillåtna tecken togs bort från namnet.',
  rename_invalid_chars: 'Namnet innehåller tecken som inte är tillåtna i SharePoint.',
  create_folder_invalid_chars: 'Mappnamnet innehåller tecken som inte är tillåtna i SharePoint.',
  rename_extension_warning: 'Att ändra filandelsen kan påverka hur filen öppnas.',
  delete: 'Ta bort',
  move_to_trash: 'Flytta till papperskorg',
  remove_permanently: 'Ta bort permanent',
  delete_item_confirm: 'Ta bort "%1"?',
  delete_confirm_checkbox: 'Jag förstår att detta inte kan ångras',
  delete_file_confirm: 'Ta bort filen "%1"?',
  delete_item_type_file: 'Fil',
  delete_item_type_folder: 'Mapp',
  delete_folder_has_content_with_count: 'Denna mapp innehåller %1 objekt. Om du tar bort den raderas även inkluderade filer och mappar.',
  DELETE_LOCK_HINT_FOLDER_LOCKED_BY_USER: 'Kan inte ta bort mappen eftersom "%2" ar oppen av %1. Be anvandaren stanga filen och forsok igen.',
  DELETE_LOCK_HINT_FOLDER_FILE_IN_USE: 'Kan inte ta bort mappen eftersom "%1" anvands just nu. Stang filen och forsok igen.',
  DELETE_HINT_FOLDER_NOT_EMPTY: 'Kan inte ta bort mappen just nu. Forsok igen om en stund.',
  DELETE_HINT_FOLDER_NOT_EMPTY_WITH_COUNT: 'Kan inte ta bort mappen just nu. Forsok igen om en stund.',
  advanced_upload: 'Avancerad spara bilagor',
  advanced_upload_partial_match: 'Matchade %1 av %2 dragna bilagor. Du kan fortfarande välja i listan nedan.',
  rename_attachments: 'Byt namn bilagor',
  rename_attachments_dialog_title: 'Spara/namnge bilagor',
  save_attachments_to_folder: 'Spara bilagor till mapp',
  attachment_name: 'Bilagenamn',
  attachment_name_with_index: '%1 %2',
  attachment_name_duplicate: 'Bilagenamn måste vara unika.',
  attachment_name_exists_in_target: 'Filen finns. Byt namn eller spara som ny version.',
  overwrite_file_confirm: 'Filen "%1" finns redan. Klicka Skriv över för att ersätta den eller Avbryt för att avbryta.',
  overwrite_dialog_title: 'Skriv över fil?',
  overwrite_action: 'Skriv över',
  abort_action: 'Avbryt',
  uploaded_to_folder: 'Uppladdad till: %1',
  DROP_SAVE_SUCCESS: 'Sparades.',
  SEND_AND_FILE_SUCCESS: 'Skickades och sparades.',
  SEND_AND_FILE_WAIT_MESSAGE: 'Skicka och spara arbetar. Stäng inte skrivfönstret.',
  select_all_none: 'Markera ohanterade/inga bilagor',
  save: 'Spara',
  save_to_folder: 'Spara till mapp',
  save_to_folder_tooltip: 'Ladda upp valda bilagor till målmappen med filnamnen som visas i listan. Dialogen förblir öppen så att du kan fortsätta spara till andra mappar.',
  save_pdf_copy: 'Spara kopia som PDF',
  save_pdf_copy_disabled: 'Spara kopia som PDF (inte tillgängligt för denna filtyp)',
  save_pdf_copy_unsupported_tooltip: 'Inte tillgängligt för denna filtyp. Filtyper som stöds: %1',
  save_as: 'Spara Som',
  save_dialog_title: 'Spara',
  save_attachments: 'Spara bilagor',
  application: 'Applikation',
  send_and_file_diagnostics: 'Diagnostik för skicka och spara',
  send_and_file_diagnostics_description: 'Kopiera de senaste 100 diagnostikhändelserna för skicka och spara. Rapporten innehåller inte e-postinnehåll, bilagenamn, mottagare, token eller meddelande-ID:n.',
  copy_send_and_file_diagnostics: 'Kopiera diagnostik',
  clear_send_and_file_diagnostics: 'Rensa diagnostik',
  send_and_file_diagnostics_copied: 'Diagnostiken har kopierats till urklipp.',
  send_and_file_diagnostics_empty: 'Ingen diagnostik för skicka och spara har registrerats.',
  send_and_file_diagnostics_copy_failed: 'Det gick inte att kopiera diagnostiken. Försök igen i en Office-klient som stöds.',
  send_and_file_export_manual_copy: 'Urklippsåtkomst är inte tillgänglig. Markera all text nedan och kopiera den manuellt.',
  copy_send_and_file_timings: 'Kopiera tider',
  clear_send_and_file_timings: 'Rensa tider',
  send_and_file_timings_copied: 'Tiderna har kopierats till urklipp.',
  send_and_file_timings_empty: 'Inga tider för skicka och spara har registrerats.',
  send_and_file: 'Skicka och spara',
  session: 'Session',
  settings_dialog_title: 'Inställningar',
  show_favorites: 'Favoriter',
  show_active: 'Endast aktiva',
  show_recent: 'Senaste',
  templates_page_title: 'Mallhanteraren',
  templates_root_node: 'Mallar',
  target_folder: 'Målmapp',
  tenant: 'Tenant',
  version: 'Version',
  user_name: 'Namn',

  PROGRESS_TITLE_UPLOAD_FILE: 'Spara',
  PROGRESS_STATUS_READ_FILE: 'Läser fildata',
  PROGRESS_STATUS_WRITE_CUSTOM_XML: 'Skriver egenskaper till xml',
  PROGRESS_STATUS_UPLOAD_FILE: 'Laddar upp till SharePoint',
  PROGRESS_STATUS_OPEN_FILE: 'Öppnar filen från SharePoint. Var god vänta',

  PROGRESS_TITLE_SEND_AND_FILE: 'Skicka och spara',
  PROGRESS_STATUS_SAVE_DRAFT_EMAIL: 'Sparar utkast',
  PROGRESS_STATUS_SET_CATEGORY_DRAFT_EMAIL: 'Sätter kategori på utkast',
  PROGRESS_STATUS_FETCH_EMAIL_WITH_RETRIES: 'Hämtar utkast från server. Detta kan ta lite tid. Var god vänta',
  PROGRESS_STATUS_SEND_DRAFT_EMAIL: 'Skickar utkast',

  PROGRESS_TITLE_UPLOAD_ATTACHMENTS: 'Spara bilagor',
  PROGRESS_STATUS_READ_ATTACHMENTS: 'Läser in bilagor från Outlook',
  PROGRESS_STATUS_UPLOAD_ATTACHMENTS: 'Laddar upp bilaga %s till SharePoint',

  PROGRESS_TITLE_LOGOUT: 'Logga ut',
  PROGRESS_STATUS_LOGOUT: 'Loggar ut',

  PROGRESS_TITLE_ATTACH_FILE: 'Lägg till bilaga',
  PROGRESS_STATUS_READ_SHAREPOINT_FILE: 'Läser fildata från SharePoint',
  PROGRESS_STATUS_ATTACH_FILE: 'Lägger till bilaga',

  ERROR_TYPE_CATEGORY_GET: 'Kunde inte hämta intranätsmappar.',
  ERROR_TYPE_CATEGORY_NOT_FOUND: 'Intranätsmapp saknas.',
  ERROR_TYPE_CATEGORY_UPDATE: 'Kunde inte ändra intranätsmapp.',
  ERROR_TYPE_CATEGORY_NO_GET_PERMISSION: 'Inte tillräcklig behörighet att läsa intranätsmapp.',
  ERROR_TYPE_CATEGORY_NO_UPDATE_PERMISSION: 'Inte tillräcklig behörighet att ändra intranätsmapp.',

  ERROR_TYPE_CONTACT_GET: 'Kunde inte hämta kontakter.',
  ERROR_TYPE_CONTACT_NOT_FOUND: 'Kontakten saknas.',
  ERROR_TYPE_CONTACT_UPDATE: 'Kunde inte ändra kontakten.',
  ERROR_TYPE_CONTACT_NO_GET_PERMISSION: 'Inte tillräcklig behörighet att läsa kontakt.',
  ERROR_TYPE_CONTACT_NO_UPDATE_PERMISSION: 'Inte tillräcklig behörighet att ändra kontakt.',

  ERROR_TYPE_CONTENT_TYPE_GET: 'Kunde inte hämta innehållstyper.',
  ERROR_TYPE_CONTENT_TYPE_NOT_FOUND: 'Innehållstypen saknas.',
  ERROR_TYPE_CONTENT_TYPE_NO_GET_PERMISSION: 'Inte tillräcklig behörighet att läsa innehållstyper.',

  ERROR_TYPE_DEPARTMENT_GET: 'Kunde inte hämta intranätsdelar.',
  ERROR_TYPE_DEPARTMENT_NOT_FOUND: 'Intranätsdelen saknas.',
  ERROR_TYPE_DEPARTMENT_UPDATE: 'Kunde inte ändra intranätsdelen.',
  ERROR_TYPE_DEPARTMENT_NO_GET_PERMISSION: 'Inte tillräcklig behörighet att läsa intranätsdel.',
  ERROR_TYPE_DEPARTMENT_NO_UPDATE_PERMISSION: 'Inte tillräcklig behörighet att ändra intranätsdel.',

  ERROR_TYPE_DOC_LIB_GET: 'Kunde inte hämta filer från dokumentbibliotek.',

  ERROR_TYPE_EMAIL_READ: 'Kunde inte läsa mejl.',
  ERROR_TYPE_EMAIL_SAVE_DRAFT: 'Kunde inte spara mejlutkast.',
  ERROR_TYPE_EMAIL_SEND: 'Kunde inte skicka mejl.',

  ERROR_TYPE_FILE_ATTACH: 'Kunde inte lägga till bilaga.',
  ERROR_TYPE_FILE_READ: 'Kunde inte läsa fildata.',
  ERROR_TYPE_FILE_READ_ATTACHMENTS: 'Kunde inte läsa filbilagor.',
  ERROR_TYPE_FILE_SAVED_ADD: 'Kunde inte lägga till filevent.',
  ERROR_TYPE_FILE_SAVED_NO_ADD_PERMISSION: 'Inte tillräcklig behörighet att lägga till filevent.',
  ERROR_TYPE_FILE_SAVE: 'Kunde inte spara filen.',
  ERROR_TYPE_FILE_LOCKED: 'Filen är låst eller används just nu. Stäng den och försök igen om en stund.',
  ERROR_TYPE_FILE_PDF_CONVERSION: 'Den valda filen kunde inte konverteras till PDF. Prova en annan fil eller lägg till utskrivbart innehåll och försök igen.',
  ERROR_TYPE_FILE_SEARCH: 'Kunde inte söka efter filer.',
  ERROR_TYPE_FILE_UPLOAD: 'Kunde inte ladda upp filen.',
  ERROR_TYPE_FILE_UPLOAD_ATTACHMENTS: 'Kunde inte ladda upp filbilagor.',
  ERROR_TYPE_FILE_RENAME: 'Kunde inte byta namn.',
  ERROR_TYPE_FILE_RENAME_INVALID: 'Kunde inte byta namn. Kontrollera att namnet är giltigt och inte redan finns.',
  ERROR_TYPE_FILE_RENAME_LOCKED: 'Kunde inte byta namn. Filen är låst eller används just nu. Prova igen om en stund.',
  FILE_LOCK_HINT_GENERIC: 'Filen är låst eller används just nu. Stäng den och försök igen om en stund.',
  FILE_LOCK_HINT_LOCKED_BY_USER: 'Låst av %1. Be den användaren stänga dokumentet och försök sedan igen.',
  FILE_LOCK_HINT_CHECKED_OUT_BY_USER: 'Utcheckad av %1. Be den användaren checka in eller stänga dokumentet och försök sedan igen.',
  RENAME_LOCK_HINT_GENERIC: 'Filen eller mappen används just nu. Stäng den i Word/Outlook och försök igen om en stund.',
  RENAME_LOCK_HINT_LOCKED_BY_USER: 'Låst av %1. Be den användaren stänga dokumentet och försök sedan igen.',
  RENAME_LOCK_HINT_FOLDER_LOCKED_BY_USER: 'En fil i mappen är låst av %1 (%2). Be den användaren stänga filen och försök sedan igen.',
  RENAME_LOCK_HINT_FOLDER_FILE_IN_USE: 'En fil i mappen används just nu (%1). Stäng den och försök igen.',
  ERROR_TYPE_FILE_DELETE: 'Kunde inte ta bort filen.',
  ERROR_TYPE_FOLDER_NOT_EMPTY: 'Kunde inte ta bort mappen.',
  ERROR_TYPE_FOLDER_CREATED_ADD: 'Kunde inte skapa upp mappen.',
  ERROR_TYPE_PROJECT_GET: 'Kunde inte hämta projekt.',
  ERROR_TYPE_PROJECT_NOT_FOUND: 'Projektet saknas.',
  ERROR_TYPE_PROJECT_UPDATE: 'Kunde inte ändra projektet.',
  ERROR_TYPE_PROJECT_NO_GET_PERMISSION: 'Inte tillräcklig behörighet att läsa projekt.',
  ERROR_TYPE_PROJECT_NO_UPDATE_PERMISSION: 'Inte tillräcklig behörighet att ändra projekt.',

  // Generic errors.

  ERROR_TYPE_AUTH: 'Autentiseringsfel. Prova att logga in igen.',
  ERROR_TYPE_LOGIN: 'Kunde inte logga in. Kontakta din administratör och se till att du har ett konto registrerat hos PDS.',
  ERROR_TYPE_NETWORK: 'Nätverksproblem. Se till att du har en fungerande internetuppkoppling.',
  ERROR_TYPE_UNKNOWN: 'Okänt problem. Var god försök igen om en stund.',
  error_with_details: '%1 (%2)',

  // Content type fields
  pdscol_archived_date: 'Arkiveringsdatum',
  pdscol_contact_name: 'Kontakt',
  pdscol_document_class: 'Dokumenttyp',
  pdscol_document_date: 'Dokumentdatum',
  pdscol_document_information: 'Dokumentinformation',
  pdscol_document_status: 'Dokumentstatus',
  pdscol_entity: 'Område',
  pdscol_gdpr: 'GDPR',
  pdscol_object_type: 'Typ',
  pdscol_responsible: 'Ansvarig',
  pdscol_system_owner: 'Systemägare',
  pdscol_tags: 'Taggar',
  pdscol_contact_number: 'Kontaktnummer',
  pdscol_project_name: 'Projekt',
  pdscol_project_number: 'Projektnummer',
  pdscol_project_responsible: 'Projektansvarig',
  pdscol_department: 'Avdelning',
  pdscol_reference_id1: 'Avser referens till id 1',
  pdscol_reference_id2: 'Avser referens till id 2',
  pdscol_time_reference: 'Avser referens till tid',
  pdscol_email_receiver_address: 'Mottagare av e-post',
  pdscol_email_send_address: 'Avsändare av e-post',
  pdscol_email_sent_time: 'Tid för avsänt e-post',
  pdscol_archived_time: 'Månader till arkivering',
  pdscol_template_group: 'Mallkategori',
  pdscol_template_information: 'Mallinformation'
}

const resources = {
  en_consultancy: en,
  en_lawfirm: {
    ...en,
    ERROR_TYPE_CONTACT_GET: 'Failed to get clients.',
    ERROR_TYPE_CONTACT_NOT_FOUND: 'Could not find client.',
    ERROR_TYPE_CONTACT_NO_GET_PERMISSION: 'Not enough permissions to read client.',
    ERROR_TYPE_CONTACT_NO_UPDATE_PERMISSION: 'Not enough permissions to update client.',
    ERROR_TYPE_CONTACT_UPDATE: 'Failed to update client.',
    ERROR_TYPE_PROJECT_GET: 'Failed to get matters.',
    ERROR_TYPE_PROJECT_NOT_FOUND: 'Could not find matter.',
    ERROR_TYPE_PROJECT_NO_GET_PERMISSION: 'Not enough permissions to read matter.',
    ERROR_TYPE_PROJECT_NO_UPDATE_PERMISSION: 'Not enough permissions to update matter.',
    ERROR_TYPE_PROJECT_UPDATE: 'Failed to update matter.',
    contact_page_title: 'Clients',
    pdscol_contact_name: 'Client',
    pdscol_contact_number: 'Client Number',
    pdscol_document_class: 'Document Class',
    pdscol_project_name: 'Matter',
    pdscol_project_number: 'Matter Number',
    pdscol_project_responsible: 'Matter Responsible',
    project_page_title: 'Matters'
  },
  es_consultancy: {
    attach: 'Adjuntar',
    add_to_email: 'Anadir al correo',
    attach_as_pdf: 'Adjuntar como PDF',
    attach_as_pdf_save_copy: 'Adjuntar como PDF y guardar copia',
    cancel: 'Cancelar',
    change_sort: 'Cambiar ordenación',
    clear: 'Limpiar',
    close: 'Cerrar',
    contact_page_title: 'Contactos',
    contact_manager_menu_title: 'PDS CM',
    contact_person_title: 'Personas de contacto',
    create_folder: 'Crear carpeta',
    document_library: 'Documentos',
    email: 'Email',
    favorite: 'Favorito',
    explain_login: 'No tiene una cuenta con PDS. Contacte con su administrador o envíenos un email para que lo configuremos para su organización',
    filename: 'Nombre de archivo',
    file_search_clear: 'Limpiar búsqueda',
    file_search_tooltip_idle: 'Buscar',
    file_search_tooltip_searching: 'Buscando',
    file_search_no_results: 'No hay resultados.',
    fill_content_control: 'Rellenar',
    intranet_page_title: 'Intranet',
    language: 'Idioma',
    loading: 'Cargando...',
    login_error_retry_button: 'Recargar la página e intentar de nuevo',
    login_error_logout_button: 'Cerrar sesión e intentar de nuevo',
    logout: 'Cerrar sesión',
    mailto_subject: '¡Me gustaría contratar / configurar PDS para mi organización!',
    navigate_first_page: 'Primera página',
    navigate_back_many: '-10',
    navigate_back: '-1',
    navigate_forward: '+1',
    navigate_forward_many: '+10',
    navigate_last_page: 'Última página',
    page_info: 'Pagina / Total de paginas',
    items_per_page: 'Elementos por pagina',
    no_options: 'No hay opciones',
    open: 'Abrir',
    save_pdf_copy_unsupported_tooltip: 'No disponible para este tipo de archivo. Tipos de archivo compatibles: %1',
    oops_title: '¡Oops!',
    paste_person_data: 'Pegar',
    people_dialog_title: 'Usuarios con roles',
    project_page_title: 'Proyectos',
    page_title_with_pagination: '%1 (%2/%3)',
    reply: 'Contestar',
    reply_all: 'Contestar a todos',
    rename: 'Renombrar',
    rename_name_exists: 'Ya existe un elemento con ese nombre en esta carpeta.',
    rename_invalid_chars_removed: 'Se eliminaron caracteres no validos del nombre.',
    rename_invalid_chars: 'El nombre contiene caracteres que no están permitidos en SharePoint.',
    create_folder_invalid_chars: 'El nombre de la carpeta contiene caracteres que no están permitidos en SharePoint.',
    rename_extension_warning: 'Cambiar la extension del archivo puede afectar como se abre el archivo.',
    delete: 'Eliminar',
    move_to_trash: 'Mover a la papelera',
    remove_permanently: 'Eliminar permanentemente',
    delete_item_confirm: '¿Eliminar "%1"?',
    delete_confirm_checkbox: 'Entiendo que esto no se puede deshacer',
    delete_file_confirm: '¿Eliminar el archivo "%1"?',
    delete_item_type_file: 'Archivo',
    delete_item_type_folder: 'Carpeta',
    delete_folder_has_content_with_count: 'Esta carpeta contiene %1 elemento(s). Al eliminarla se eliminarán también los archivos y carpetas incluidos.',
    DELETE_LOCK_HINT_FOLDER_LOCKED_BY_USER: 'No se puede eliminar esta carpeta porque "%2" esta abierto por %1. Pida a ese usuario que cierre el archivo e intentelo de nuevo.',
    DELETE_LOCK_HINT_FOLDER_FILE_IN_USE: 'No se puede eliminar esta carpeta porque "%1" esta en uso. Cierre el archivo e intentelo de nuevo.',
    DELETE_HINT_FOLDER_NOT_EMPTY: 'No se puede eliminar esta carpeta ahora mismo. Intentelo de nuevo en un momento.',
    DELETE_HINT_FOLDER_NOT_EMPTY_WITH_COUNT: 'No se puede eliminar esta carpeta ahora mismo. Intentelo de nuevo en un momento.',
    advanced_upload: 'Guardado avanzado de adjuntos',
    advanced_upload_partial_match: 'Se han encontrado %1 de %2 adjuntos arrastrados. Aun puede seleccionar en la lista inferior.',
    rename_attachments: 'Renombrar adjuntos',
    rename_attachments_dialog_title: 'Renombrar adjuntos',
    save_attachments_to_folder: 'Guardar adjuntos en carpeta',
    attachment_name: 'Nombre del adjunto',
    attachment_name_with_index: '%1 %2',
    attachment_name_duplicate: 'Los nombres de adjuntos deben ser unicos.',
    attachment_name_exists_in_target: 'El archivo ya existe. Renombrelo o guarde como una nueva version.',
    overwrite_file_confirm: 'El archivo "%1" ya existe. Haga clic en Sobrescribir para reemplazarlo o en Abortar para cancelar.',
    overwrite_dialog_title: 'Sobrescribir archivo?',
    overwrite_action: 'Sobrescribir',
    abort_action: 'Abortar',
    uploaded_to_folder: 'Subido a: %1',
    DROP_SAVE_SUCCESS: 'Guardado correctamente.',
    SEND_AND_FILE_SUCCESS: 'Enviado y guardado correctamente.',
    SEND_AND_FILE_WAIT_MESSAGE: 'Enviar y archivar está en curso. No cierre la ventana de redacción.',
    select_all_none: 'Seleccionar todo/ninguno',
    save: 'Guardar',
    save_to_folder: 'Guardar en carpeta',
    save_to_folder_tooltip: 'Sube los adjuntos seleccionados a la carpeta de destino usando los nombres de archivo que se muestran en esta lista. El dialogo permanece abierto para que pueda seguir guardando en otras carpetas.',
    save_as: 'Cuardar como',
    save_dialog_title: 'Guardar',
    save_attachments: 'Guardar adjuntos',
    application: 'Aplicacion',
    send_and_file_diagnostics: 'Diagnostico de enviar y archivar',
    send_and_file_diagnostics_description: 'Copia los ultimos 100 eventos de diagnostico de enviar y archivar. El informe no contiene contenido del correo, nombres de adjuntos, destinatarios, tokens ni ID de mensajes.',
    copy_send_and_file_diagnostics: 'Copiar diagnostico',
    clear_send_and_file_diagnostics: 'Borrar diagnostico',
    send_and_file_diagnostics_copied: 'El diagnostico se copio al portapapeles.',
    send_and_file_diagnostics_empty: 'No se han registrado diagnosticos de enviar y archivar.',
    send_and_file_diagnostics_copy_failed: 'No se pudo copiar el diagnostico. Intentalo de nuevo en un cliente de Office compatible.',
    send_and_file_export_manual_copy: 'El acceso al portapapeles no está disponible. Seleccione todo el texto siguiente y cópielo manualmente.',
    copy_send_and_file_timings: 'Copiar tiempos',
    clear_send_and_file_timings: 'Borrar tiempos',
    send_and_file_timings_copied: 'Los tiempos se copiaron al portapapeles.',
    send_and_file_timings_empty: 'No se han registrado tiempos de enviar y archivar.',
    send_and_file: 'Enviar y archivar',
    session: 'Sesión',
    settings_dialog_title: 'Configuración',
    show_favorites: 'Favoritos',
    show_active: 'Solo activos',
    show_recent: 'Recientes',
    templates_page_title: 'Plantillas',
    templates_root_node: 'Plantillas',
    target_folder: 'Carpeta de destino',
    tenant: 'Instancia',
    version: 'Version',
    user_name: 'Nombre',

    PROGRESS_TITLE_UPLOAD_FILE: 'Guardar',
    PROGRESS_STATUS_READ_FILE: 'Leyendo datos del archivo',
    PROGRESS_STATUS_WRITE_CUSTOM_XML: 'Generando XML personalizado',
    PROGRESS_STATUS_UPLOAD_FILE: 'Subiendo datos a SharePoint',
    PROGRESS_STATUS_OPEN_FILE: 'Abriendo archivo en SharePoint. Por favor espere',

    PROGRESS_TITLE_SEND_AND_FILE: 'Enviar y archivar',
    PROGRESS_STATUS_SAVE_DRAFT_EMAIL: 'Guardando borrador',
    PROGRESS_STATUS_SET_CATEGORY_DRAFT_EMAIL: 'Establecer categoría en borrador',
    PROGRESS_STATUS_FETCH_EMAIL_WITH_RETRIES: 'Obteniendo borradores desde el servidor. Esta operación puede tardar un poco, por favor espere',
    PROGRESS_STATUS_SEND_DRAFT_EMAIL: 'Enviando borrador',

    PROGRESS_TITLE_UPLOAD_ATTACHMENTS: 'Guardar archivos adjuntos',
    PROGRESS_STATUS_READ_ATTACHMENTS: 'Leyendo datos de archivos adjuntos desde Outlook',
    PROGRESS_STATUS_UPLOAD_ATTACHMENTS: 'Subiendo archivo adjunto %s a SharePoint',

    PROGRESS_TITLE_LOGOUT: 'Cerrar sesión',
    PROGRESS_STATUS_LOGOUT: 'Cerrando sesión',

    PROGRESS_TITLE_ATTACH_FILE: 'Añadir adjunto',
    PROGRESS_STATUS_READ_SHAREPOINT_FILE: 'Leyendo archivo desde SharePoint',
    PROGRESS_STATUS_ATTACH_FILE: 'Adjuntando archivo al correo',

    // Error messages

    ERROR_TYPE_CATEGORY_GET: 'Error al obtener las carpetas de la intranet.',
    ERROR_TYPE_CATEGORY_NOT_FOUND: 'No se pudo encontrar la carpeta de la intranet.',
    ERROR_TYPE_CATEGORY_UPDATE: 'Error al actualizar la carpeta de la intranet.',
    ERROR_TYPE_CATEGORY_NO_GET_PERMISSION: 'No tiene permisos para acceder a la carpeta de la intranet.',
    ERROR_TYPE_CATEGORY_NO_UPDATE_PERMISSION: 'No tiene permisos para actualizar la carpeta de la intranet.',

    ERROR_TYPE_CONTACT_GET: 'Error al obtener los contactos.',
    ERROR_TYPE_CONTACT_NOT_FOUND: 'No se pudo encontrar el contacto.',
    ERROR_TYPE_CONTACT_UPDATE: 'Error al actualizar el contacto.',
    ERROR_TYPE_CONTACT_NO_GET_PERMISSION: 'No tiene permisos para acceder al contacto.',
    ERROR_TYPE_CONTACT_NO_UPDATE_PERMISSION: 'No tiene permisos para actualizar el contacto.',

    ERROR_TYPE_CONTENT_TYPE_GET: 'Error al obtener los tipos de contenido.',
    ERROR_TYPE_CONTENT_TYPE_NOT_FOUND: 'No se pudo encontrar el tipo de contenido.',
    ERROR_TYPE_CONTENT_TYPE_NO_GET_PERMISSION: 'No tiene permisos para obtener los tipos de contenido.',

    ERROR_TYPE_DEPARTMENT_GET: 'Error al obtener las secciones de la intranet.',
    ERROR_TYPE_DEPARTMENT_NOT_FOUND: 'No se pudo encontrar la sección de la intranet.',
    ERROR_TYPE_DEPARTMENT_UPDATE: 'Error al actualizar las secciones de la intranet.',
    ERROR_TYPE_DEPARTMENT_NO_GET_PERMISSION: 'No tiene permisos para leer las secciones de la intranet.',
    ERROR_TYPE_DEPARTMENT_NO_UPDATE_PERMISSION: 'No tiene permisos para actualizar la sección de la intranet.',

    ERROR_TYPE_DOC_LIB_GET: 'Error al obtener archivos desde la galería de documentos.',

    ERROR_TYPE_EMAIL_READ: 'Error al obtener email.',
    ERROR_TYPE_EMAIL_SAVE_DRAFT: 'Error al guardar borrador de email.',
    ERROR_TYPE_EMAIL_SEND: 'Error al enviar email.',

    ERROR_TYPE_FILE_ATTACH: 'Error al adjuntar el archivo.',
    ERROR_TYPE_FILE_READ: 'Error al leer el archivo.',
    ERROR_TYPE_FILE_READ_ATTACHMENTS: 'Error al leer los archivos adjuntos.',
    ERROR_TYPE_FILE_SAVED_ADD: 'Error al añadir el evento de archivo guardado.',
    ERROR_TYPE_FILE_SAVED_NO_ADD_PERMISSION: 'No tiene permisos para añadir el evento de archivo guardado.',
    ERROR_TYPE_FILE_SAVE: 'Error al guardar archivo.',
    ERROR_TYPE_FILE_LOCKED: 'El archivo esta bloqueado o en uso. Cierrelo y vuelva a intentarlo en un momento.',
    ERROR_TYPE_FILE_PDF_CONVERSION: 'No se pudo convertir el archivo seleccionado a PDF. Pruebe con otro archivo o agregue contenido imprimible e intente nuevamente.',
    ERROR_TYPE_FILE_SEARCH: 'Error buscando archivos.',
    ERROR_TYPE_FILE_UPLOAD: 'Error subiendo archivo.',
    ERROR_TYPE_FILE_UPLOAD_ATTACHMENTS: 'Error subiendo los archivos adjuntos.',
    ERROR_TYPE_FILE_RENAME: 'Error al renombrar el elemento.',
    ERROR_TYPE_FILE_RENAME_INVALID: 'No se pudo renombrar el elemento. Verifique que el nombre sea valido y que no este en uso.',
    ERROR_TYPE_FILE_RENAME_LOCKED: 'No se pudo renombrar el elemento. El archivo esta bloqueado o en uso. Intente de nuevo en un momento.',
    FILE_LOCK_HINT_GENERIC: 'El archivo esta bloqueado o en uso. Cierrelo y vuelva a intentarlo en un momento.',
    FILE_LOCK_HINT_LOCKED_BY_USER: 'Bloqueado por %1. Pidale a ese usuario que cierre el documento y vuelva a intentarlo.',
    FILE_LOCK_HINT_CHECKED_OUT_BY_USER: 'Extraido por %1. Pidale a ese usuario que lo devuelva o cierre el documento y vuelva a intentarlo.',
    RENAME_LOCK_HINT_GENERIC: 'El archivo o la carpeta esta en uso. Cierrelo en Word/Outlook y vuelva a intentarlo en un momento.',
    RENAME_LOCK_HINT_LOCKED_BY_USER: 'Bloqueado por %1. Pidale a ese usuario que cierre el documento y vuelva a intentarlo.',
    RENAME_LOCK_HINT_FOLDER_LOCKED_BY_USER: 'Un archivo de esta carpeta esta bloqueado por %1 (%2). Pidale a ese usuario que lo cierre y vuelva a intentarlo.',
    RENAME_LOCK_HINT_FOLDER_FILE_IN_USE: 'Un archivo de esta carpeta esta en uso (%1). Cierrelo y vuelva a intentarlo.',
    ERROR_TYPE_FILE_DELETE: 'Error al eliminar el archivo.',
    ERROR_TYPE_FOLDER_NOT_EMPTY: 'No se pudo eliminar la carpeta.',
    ERROR_TYPE_FOLDER_CREATED_ADD: 'No se pudo crear la carpeta',
    ERROR_TYPE_PROJECT_GET: 'Error al obtener los proyectos.',
    ERROR_TYPE_PROJECT_NOT_FOUND: 'No se pudo encontrar el proyecto.',
    ERROR_TYPE_PROJECT_UPDATE: 'Error al actualizar el proyecto.',
    ERROR_TYPE_PROJECT_NO_GET_PERMISSION: 'No tiene permisos para leer el proyecto.',
    ERROR_TYPE_PROJECT_NO_UPDATE_PERMISSION: 'No tiene permisos para actualizar el proyecto.',

    // Generic errors.

    ERROR_TYPE_AUTH: 'Error de autenticación. Intente acceder de nuevo.',
    ERROR_TYPE_LOGIN: 'Error al iniciar sesión. Contacte con su administrador y asegúrese de que tiene una cuenta registrada con PDS.',
    ERROR_TYPE_NETWORK: 'No se puede conectar. Asegúrese de que dispone de conexión a Internet.',
    ERROR_TYPE_UNKNOWN: 'Error no especificado. Por favor vuelva a intentarlo de nuevo más tarde.',
    error_with_details: '%1 (%2)',

    // Content type fields
    pdscol_archived_date: 'Fecha de archivado',
    pdscol_contact_name: 'Contacto',
    pdscol_document_class: 'Tipo de documento',
    pdscol_document_date: 'Fecha del documento',
    pdscol_document_information: 'Información del documento',
    pdscol_document_status: 'Estado del documento',
    pdscol_entity: 'Área',
    pdscol_gdpr: 'GDPR',
    pdscol_object_type: 'Tipo',
    pdscol_responsible: 'Responsable',
    pdscol_system_owner: 'Propietario del sistema',
    pdscol_tags: 'Etiquetas',
    pdscol_contact_number: 'Número del contacto',
    pdscol_project_name: 'Proyecto',
    pdscol_project_number: 'Número del proyecto',
    pdscol_project_responsible: 'Responsable del proyecto',
    pdscol_department: 'Departamento',
    pdscol_reference_id1: 'Id. de referencia 1',
    pdscol_reference_id2: 'Id. de referencia 2',
    pdscol_time_reference: 'Fecha de referencia',
    pdscol_email_receiver_address: 'Receptor del email',
    pdscol_email_send_address: 'Emisor del email',
    pdscol_email_sent_time: 'Fecha de envío del email',
    pdscol_archived_time: 'Meses hasta el archivado',
    pdscol_template_group: 'Grupo de la plantilla',
    pdscol_template_information: 'Información de la plantilla'
  },
  sv_consultancy: sv,
  sv_lawfirm: {
    ...sv,
    ERROR_TYPE_CONTACT_GET: 'Kunde inte hämta klienter.',
    ERROR_TYPE_CONTACT_NOT_FOUND: 'Klienten saknas.',
    ERROR_TYPE_CONTACT_NO_GET_PERMISSION: 'Inte tillräcklig behörighet att läsa klient.',
    ERROR_TYPE_CONTACT_NO_UPDATE_PERMISSION: 'Inte tillräcklig behörighet att ändra klient.',
    ERROR_TYPE_CONTACT_UPDATE: 'Kunde inte ändra klienten.',
    ERROR_TYPE_PROJECT_GET: 'Kunde inte hämta ärenden.',
    ERROR_TYPE_PROJECT_NOT_FOUND: 'Ärendet saknas.',
    ERROR_TYPE_PROJECT_NO_GET_PERMISSION: 'Inte tillräcklig behörighet att läsa ärende.',
    ERROR_TYPE_PROJECT_NO_UPDATE_PERMISSION: 'Inte tillräcklig behörighet att ändra ärende.',
    ERROR_TYPE_PROJECT_UPDATE: 'Kunde inte ändra ärendet.',
    contact_page_title: 'Klienter',
    pdscol_contact_name: 'Klient',
    pdscol_contact_number: 'Klientnummer',
    pdscol_document_class: 'Dokumentklass',
    pdscol_project_name: 'Ärende',
    pdscol_project_number: 'Ärendenummer',
    pdscol_project_responsible: 'Ärendeansvarig',
    project_page_title: 'Ärenden'
  }
}

export default resources
